"use client";

import {
  realProductImages,
} from "@/data/product-images";

type Props = {
  productId: string;
  fallback: string;
  alt: string;
  className?: string;
  loading?: "eager" | "lazy";
  fetchPriority?: "high" | "low" | "auto";
};

export default function ProductPhoto({
  productId,
  fallback,
  alt,
  className = "",
  loading = "lazy",
  fetchPriority = "auto",
}: Props) {
  const src =
    realProductImages[productId] ??
    fallback;

  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      fetchPriority={fetchPriority}
      decoding="async"
      draggable={false}
      className={className}
    />
  );
}
